import React from 'react';
import {
  Modal,
  Avatar,
  Button,
  Box,
  Typography,
} from '@ublend-npm/aulaui-core';
import { GOT_IT } from '@core/assignments/constants';

type GotItModalProps = {
  logo: string | undefined;
  name: string;
  textParagraph1: string;
  textParagraph2: string;
  isVisible: boolean;
  onClose: () => void;
  styles?: any;
};

const GotItModal = ({
  logo,
  name,
  textParagraph1,
  textParagraph2,
  isVisible,
  onClose,
  styles,
}: GotItModalProps) => {
  return (
    <Modal open={isVisible}>
      <Box sx={styles.gotItModalContainer}>
        <Box sx={styles.titleContainer}>
          <Avatar sx={styles.avatar} src={logo} altText={name} />
          <Typography component={'span'} sx={styles.gotItTitle} tabIndex={0}>
            {name}
          </Typography>
        </Box>
        <Typography component={'span'} sx={styles.paragraph}>
          {textParagraph1}
        </Typography>
        <Typography
          component={'span'}
          sx={{ ...styles.paragraph, mt: '0.5rem' }}
        >
          {textParagraph2}
        </Typography>
        <Button aria-label="Got it" sx={styles.gotItButton} onClick={onClose}>
          {GOT_IT}
        </Button>
      </Box>
    </Modal>
  );
};

export default GotItModal;
